import React from 'react';
import Markdown from './Markdown';

const Privacy = () => {
  return <Markdown url="https://raw.githubusercontent.com/crewtimer/crewtimer-doc/main/general/Privacy.md" />;
};

export default Privacy;
